import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import thumb_biller from 'assets/img/thumb-biller.png';
import Img from './Img';

class BillerInfo extends Component {
  static propTypes = {
    data: PropTypes.instanceOf(Object).isRequired,
    location: PropTypes.instanceOf(Object).isRequired,
  }

  render() {
    const { data, location } = this.props;
    const isAvailable = !_.isEmpty(Array.isArray(data.meta) ? data.meta : _.get(data, 'meta.parameters') || []);
    const { pathname } = location;
    return (
      <div className="bg-light">
        <div className="d-flex align-items-center px-4">
          <div
            className="img-holder img-sm d-flex align-items-center"
            style={{
              marginTop: 10,
              marginBottom: '-20px',
            }}
          >
            <Img src={data.logo} defaultSrc={thumb_biller} alt={data.name} className={`img-fluid${!isAvailable ? ' greyscale' : ''}`} />
          </div>
          <div className="ml-3 mt-3">
            <h6 className="mb-0"><b>{data.name}</b></h6>
            <ul className="list-inline mb-0 mt-1">
              <li className="list-inline-item">
                <span>
                  <b>Pay Now</b>
                </span>
              </li>
              <li className="list-inline-item">
                <span className="text-muted"><small>/</small></span>
              </li>
              <li className="list-inline-item">
                { pathname.indexOf('/summary') > -1
                  ? <span><b>Summary</b></span>
                  : <span className="text-muted">Summary</span>
                }
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(BillerInfo);
